/// <reference types="@angular/localize" />

import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { environment } from './environments/environment';
import { GlobalErrorHandler } from './app/global-error-handler';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withRouterConfig, provideRouter } from '@angular/router';
import { ROUTES } from './app/app.routes';
import { ToastrModule } from 'ngx-toastr';
import { ClipboardModule } from 'ngx-clipboard';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AppComponent } from './app/app.component';
import localeSL from '@angular/common/locales/sl';
import localeSlExtra from '@angular/common/locales/extra/sl';
import { httpConfigInterceptor } from './app/core/interceptors/http-authorization.interceptor';
import { withCredentialsInterceptor } from './app/core/interceptors/http-with-credentials-authorization';
import { provideApiConfiguration } from './app/data/api/api-configuration';
import { reloadOnBackForwardRestore } from './app/core/browser/reload-on-back-forward-restore';

registerLocaleData(localeSL, 'sl', localeSlExtra);
reloadOnBackForwardRestore(window);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      BrowserModule,
      // No preventDuplicates: two errors that share a guidance line are still two errors, each with its own
      // description and correlation id (merging them wrote the second error's id onto the first toast).
      ToastrModule.forRoot({}),
      ClipboardModule,
      NgIdleKeepaliveModule.forRoot(),
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptors([withCredentialsInterceptor, httpConfigInterceptor])),
    provideAnimations(),
    // 'computed': when the leave check cancels a browser Back ("Ostani na obrazcu"), the history is
    // put back as it was; the default overwrote the previous entry with the form, so the next Back
    // skipped the list.
    provideRouter(ROUTES, withRouterConfig({ onSameUrlNavigation: 'reload', canceledNavigationResolution: 'computed' })),
    provideApiConfiguration('/api'),
  ],
}).catch((err) => console.error(err));
